import { ReturnFrequency } from 'store/api/enums';
import moment from 'moment';

export function calculateNextDate(
  originalDate: any,
  returnFrequency: string
): Date {
  let newDate = moment(new Date(originalDate));

  switch (ReturnFrequency[returnFrequency]) {
    case ReturnFrequency.WEEKLY:
      newDate.add(1, 'w');
      break;
    case ReturnFrequency.FORNIGHTLY:
      newDate.add(2, 'w');
      break;
    case ReturnFrequency.MONTHLY:
      newDate.add(1, 'M');
      break;
    case ReturnFrequency.TWO_MONTHS:
      newDate.add(2, 'M');
      break;
    case ReturnFrequency.FOUR_MONTHS:
      newDate.add(4, 'M');
      break;
    case ReturnFrequency.SIX_MONTHS:
      newDate.add(6, 'M');
      break;
    case ReturnFrequency.QUARTERLY:
      newDate.add(3, 'M');
      break;
    case ReturnFrequency.BI_YEARLY:
      newDate.add(2, 'y');
      break;
    case ReturnFrequency.YEARLY:
      newDate.add(1, 'y');
      break;
    default:
      break;
  }

  return newDate.toDate();
}
